export const setList = (state, payload) => state.list = payload
export const removeItem = (state, payload) => state.list.splice(payload, 1)
